var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewer-metadata"
  }, [(_vm.metadata) ? _c('ul', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "viewer-metadata__contents"
  }, _vm._l((_vm.metadata), function(item) {
    return _c('li', [_c('strong', [_vm._v(_vm._s(item.label))]), _vm._v(":\n        "), _c('span', [_vm._v(_vm._s(item.value))])])
  }))]) : _c('h4', [_vm._v("This object has no metadata to display")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewer-metadata__header"
  }, [_c('h2', [_vm._v("Metadata")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-193dc146","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/Metadata.vue
// module id = YwT4
// module chunks = 0